<template>
	<div class="class-name">
		<layout-gray class="col" gutter="20">
			<h3 align-self="center">加油！再一步就完成了！</h3>
			<SetPassword v-for="(story,i) in passwordStories" :key="i" :num="i+1" :story="story"></SetPassword>
			<p class="color-text3">下一步，要請小組成員思考要解決的問題是什麼？並於報名系統填寫「感受的問題、造成問題可能的原因」，建議您至「報名 DFC 挑戰」頁面下載「DFC 挑戰資料包」，帶領小組成員填寫學習單，以繼續完成 DFC 挑戰報名</p>
			<router-link :to="{name: 'signUp', query: {page: '1'}}" align-self="center">
				<el-button type="danger" class="color-white bg-pink1">回到報名 DFC 挑戰頁面</el-button>
			</router-link>
		</layout-gray>
	</div>
</template>

<script>
import LayoutGray from "@/components/challenge/signUp/LayoutGray.vue";
import SetPassword from "@/components/challenge/signUp/SetPassword";
import { mapState } from "vuex";

export default {
	components: { LayoutGray, SetPassword },
	data() {
		return {
			ruleForm: {
				password: ""
			},
			rules: {}
		};
	},
	computed: {
		...mapState("story", ["passwordStories"])
	},
	methods: {},
	created() { }
};
</script>